<div class="frame-parent">
  <div class="frame-group">
    <div class="title-parent">
      <div class="title">
        <div class="title1">{{ 'parking' | translate }}</div>
      </div>
      <div class="tag">
        <div class="custom-icons">
          <img class="vector-icon" alt="" src="../assets/icons/clock-icon.svg" />
        </div>
        <div class="text">{{ 'to-consult' | translate }}</div>
      </div>
    </div>
    <div class="reserva-una-plaza">
      {{ 'parking-description' | translate }}
    </div>
  </div>
  <div class="title-group">
    <div class="title">
      <div class="title1">{{ 'how-does-it-work' | translate }}</div>
    </div>
    <div class="tag-parent">
      <div class="tag1">
        <img class="iconsoutlinesearch" alt="" src="../assets/icons/search-icon-black.svg" />
        <div class="text1">{{ 'parking-how-does-it-works-text-1' | translate }}</div>
      </div>
      <div class="tag1">
        <div class="iconsoutlinesearch">
          <img class="group-icon" alt="" src="../assets/icons/paper-plane-icon.svg" />
        </div>
        <div class="text1">
          {{ 'parking-how-does-it-works-text-2' | translate }}
        </div>
      </div>
      <div class="tag1">
        <div class="iconsoutlinesearch">
          <img class="vector-icon1" alt="" src="../assets/icons/car-icon.svg" />
        </div>
        <div class="text1">
          {{ 'parking-how-does-it-works-text-3' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="button-container">
    <ng-content select="[left-button]"></ng-content>
  
    <button
      class="continue-button2"
      (click)="redirectToParking()"
    >
    {{ 'continue' | translate }}
    </button>
  </div>
